import { render, staticRenderFns } from "./MyOrderSale.vue?vue&type=template&id=0d0cf3bc&scoped=true"
import script from "./MyOrderSale.vue?vue&type=script&lang=js"
export * from "./MyOrderSale.vue?vue&type=script&lang=js"
import style0 from "./MyOrderSale.vue?vue&type=style&index=0&id=0d0cf3bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cf3bc",
  null
  
)

export default component.exports